module.exports = __webpack_public_path__ + "img/toprbk50.96bd5a7e.png";